export const teamHeroSources = {
  sources: {
    lg: {
      src: '/assets/team/background/lg/background_team_lg.webp',
      fallback: '/assets/team/background/lg/background_team_lg.jpg',
    },
    md: {
      src: '/assets/team/background/md/background_team_md.webp',
      fallback: '/assets/team/background/md/background_team_md.jpg',
    },
    default: {
      src: '/assets/team/background/default/background_team_default.webp',
      fallback: '/assets/team/background/default/background_team_default.jpg',
    },
  },
  alt: '',
};
